import { createFileRoute } from "@tanstack/react-router";

import PeriodsPage from "@/features/dashboard/pages/periods";

export const Route = createFileRoute("/(app)/dashboard/periods/")({
  component: () => <PeriodsPage />,
});
